import axios from 'axios'


const SESSION_TTL = 30000 // 30 seconds

export default {
  
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user : {},
    lastServerResponse: parseInt(localStorage.getItem('lastServerResponse') || '0', 10),
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, payload){
      state.status = 'success'
      state.token = payload.token
      state.user = payload.user || {}
      state.lastServerResponse = Date.now()
      localStorage.setItem('lastServerResponse', String(state.lastServerResponse))
    },
    auth_error(state){
      state.status = 'error'
    },
    setUser(state, user){
      state.user = user || {}
    },
    touchSession(state) {
      state.lastServerResponse = Date.now()
      localStorage.setItem('lastServerResponse', String(state.lastServerResponse))
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.user = {}
      state.lastServerResponse = 0
      localStorage.removeItem('lastServerResponse')
    },
  },
  actions: {
    async login({commit}, user){
      return await new Promise((resolve, reject) => {
        commit('auth_request')
         axios('/auth/login', {
           
           data: user,
           method: 'POST'
         })
        .then(resp => {
          const token = resp.data.token;
          const user = resp.data.user;
          if(token){
             localStorage.setItem('token', token);
             axios.defaults.headers.common['user-auth-key'] = token;
            commit('auth_success', { token, user })
            resolve(resp)
           } else{
              localStorage.removeItem('token')
              localStorage.removeItem('lastServerResponse')
              delete axios.defaults.headers.common['user-auth-key']
             commit('auth_error')
             reject(resp.data.error)
           }
           return resp
         })
            .catch(err => {
            localStorage.removeItem('token')
            localStorage.removeItem('lastServerResponse')
            delete axios.defaults.headers.common['user-auth-key']
            commit('auth_error')
            reject(err)
            return err
          })

      })
    },
    

      logout({commit}){
        return new Promise((resolve, reject) => {
          commit('logout')
          localStorage.removeItem('token')
          localStorage.removeItem('lastServerResponse')
          delete axios.defaults.headers.common['user-auth-key']
          resolve()
        })
       },



     async updatePassword({commit}, updatePassword) {
      var result;
      try {
        return await axios
          ('/crm/users/update/', {
            method: 'POST',
            data: updatePassword
            
          })
          .then(response => (result = response, console.log(response)))
          .catch(error => console.log(error));
      } catch (e) {
          console.log(e);
          throw e;
      }
    },

  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    isSessionFresh: state => !state.token || (Date.now() - state.lastServerResponse < SESSION_TTL),
  }
}